// The handleResponse function checks responses from the api to see if the request was unauthorised, forbidden or unsuccessful.

// If the response status is 401 Unauthorized or 403 Forbidden then the user is automatically logged out of the application,
// this handles if the user token is no longer valid for any reason. If the response contains an error
// then a rejected promise is returned that includes the error message, otherwise if the request was successful then the response data is returned as a JSON object.

const parseResponseText = (text: string) => {
  if (!text) {
    return null;
  }

  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
};

const rejectIfResponseNotOk = async (response: Response, data: any) => {
  const { status, statusText } = response;

  if (response.ok) {
    return undefined;
  }

  if ([403].indexOf(status) !== -1) {
    // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
    // authService.logout();

    // if errcode 6 (licence expired)
    if (data && typeof data === 'object' && data.errcode && data.errcode === 6) {
      return Promise.reject({
        message: statusText,
        status,
        detail: {
          errcode: data.errcode,
          errmsg: data.message,
        },
      });
    }
    localStorage.removeItem('auth_token');
    window.location.href = '/';
  }

  return Promise.reject({ status, message: statusText, detail: data });
};

export default async function handleResponse(response: Response): Promise<JSON> {
  const text = await response.text();
  const data = parseResponseText(text);

  await rejectIfResponseNotOk(response, data);

  return Promise.resolve(data);
}

export async function handleFileResponse(response: Response): Promise<Blob> {
  if (!response.ok) {
    const text = await response.text();
    const data = parseResponseText(text);
    await rejectIfResponseNotOk(response, data);
  }

  return response.blob();
}
